module.exports = __webpack_public_path__ + "img/DOGE_COIN.76beb4cf.svg";